import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFormPageApp } from './FormPageAppContext';

export default function FormHeaderLab({ taskId, taskUrl, taskParams }) {
  const { apiClient, apiUrlContext, authTokenContext, ConfirmationModal } =
    useFormPageApp();
  const api_url = useContext(apiUrlContext);
  const token = useContext(authTokenContext);
  const navigate = useNavigate();

  function requestTaskReturnClick(id) {
    const params = { operation: 'request-task-return' };

    apiClient
      .put(api_url + taskUrl + taskId, params, {
        headers: {
          Authorization: token,
        },
      })
      .then(
        () => {
          navigate(0);
        },
        (error) => {
          console.log(error);
          alert(error.response?.data || 'Не удалось запросить возврат задания');
        }
      );
  }

  return (
    <>
      <ConfirmationModal
        modalId="confirmTaskReturnRequestModal"
        headerText="Задание"
        messageText={['Вы уверены, что хотите запросить возврат задания?']}
        confirmButtonText="Запросить возврат"
        Action={() => requestTaskReturnClick(taskId)}
      />

      {['SENT', 'EXPORTED_TO_EAS'].includes(taskParams.status) ?
        (
          <>
            <div className="row m-3">
              <div className='col-9'>
                <div className="form-head p-3 d-grid gap-3 d-md-flex justify-content-between">
                  <div>
                    <h6 className="mb-0">Задание отправлено на проверку</h6>
                    {taskParams.return_requested && <p className='mt-3'><small>отправлен запрос на возврат задания</small></p>}
                  </div>
                  <div className="dropdown mt-3 me-3">
                    <button
                      className="btn lk-button dropdown-toggle px-4"
                      type="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      Действия
                    </button>
                    <ul className="dropdown-menu">
                      {taskParams.return_requested ? (
                        <button
                          className="dropdown-item lk-menu-dropdown"
                          disabled
                        >
                          Запрос на возврат отправлен
                        </button>
                      ) : (
                        <button
                          className="dropdown-item lk-menu-dropdown"
                          data-bs-toggle="modal"
                          data-bs-target="#confirmTaskReturnRequestModal"
                        >
                          Запросить возврат задания
                        </button>
                      )}
                    </ul>
                  </div>
                </div>
              </div>
            </div>   
          </>
        )
      :
        ( 
          <div className="row mt-3 me-3 mb-3" style={{ marginLeft: '30px'}}>
            <div className='col-9 ps-0'>
              <div className="form-head p-3">
                <h6>Цикл: <b>{taskParams.form?.cycle}</b></h6>
                <h6>Представление результатов до: <b>{taskParams.deadline_date}</b></h6>
                <h6>Номера ОПК: {taskParams.samples}</h6> 
              </div>
            </div>
          </div> 
        )
      }

      {taskParams.status === 'PENDING' &&
        (
          <>
            <div className="row m-3">
              <div className='col-9'>
                <div className="form-head p-3">
                  <h6><span className="text-danger fw-bold">Задание станет доступно для редактирования начиная с {taskParams.start_date}</span></h6>
                </div>
              </div>
            </div>   
          </>
        )
      }      
    </>
  )
}
